import api from './api';

export interface Customer {
  id: string;
  fullName: string;
  phoneNumber: string;
  address: string;
  code: string;
  createdAt: string;
}

export const customerV1Service = {
  // Lấy khách lẻ mặc định
  getDefaultCustomer: async (): Promise<Customer> => {
    try {
      // Tìm khách lẻ trong danh sách khách hàng
      const response = await api.get('/api/customers', {
        params: { search: 'Khách lẻ', pageSize: '1' }
      });
      
      if (response.data.data && response.data.data.length > 0) {
        const defaultCustomer = response.data.data[0];
        return {
          id: defaultCustomer.id.toString(),
          fullName: defaultCustomer.name || 'Khách lẻ', // API trả về 'name'
          phoneNumber: defaultCustomer.phone || '0000000000', // API trả về 'phone'
          address: defaultCustomer.address || '',
          code: defaultCustomer.code || 'CUS-KHACHLE',
          createdAt: defaultCustomer.created_at
        };
      }

      // Nếu không tìm thấy, tạo khách lẻ mặc định
      return {
        id: '0',
        fullName: 'Khách lẻ',
        phoneNumber: '0000000000',
        address: '',
        code: 'CUS-KHACHLE',
        createdAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error getting default customer:', error);
      // Trả về khách lẻ mặc định khi offline
      return {
        id: '0',
        fullName: 'Khách lẻ',
        phoneNumber: '0000000000',
        address: '',
        code: 'CUS-KHACHLE',
        createdAt: new Date().toISOString()
      };
    }
  },

  // Tìm kiếm khách hàng
  searchCustomers: async (query: string): Promise<Customer[]> => {
    try {
      const response = await api.get('/api/customers', {
        params: { search: query, pageSize: '20' }
      });
      
      return response.data.data.map((customer: any) => ({
        id: customer.id.toString(),
        fullName: customer.name, // API trả về 'name'
        phoneNumber: customer.phone, // API trả về 'phone'
        address: customer.address,
        code: customer.code,
        createdAt: customer.created_at
      }));
    } catch (error) {
      console.error('Error searching customers:', error);
      throw error;
    }
  },

  // Tạo khách hàng mới
  createCustomer: async (customerData: Partial<Customer>): Promise<Customer> => {
    try {
      const response = await api.post('/api/customers', {
        code: `CUS-${Date.now()}`, // Tự động tạo mã
        name: customerData.fullName, // API mong đợi 'name'
        phone: customerData.phoneNumber, // API mong đợi 'phone'
        address: customerData.address
      });
      
      return {
        id: response.data.customerId.toString(),
        fullName: customerData.fullName!,
        phoneNumber: customerData.phoneNumber!,
        address: customerData.address || '',
        code: response.data.code,
        createdAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  }
};